import { useRouter } from "next/router";
import React, { FC } from "react";
import {
  Benefits,
  Contacts,
  GetInterested,
  Intro,
  AboutApp,
  AboutCompany,
} from "../components/index";

import { WithRootLayout } from "../hoc/withRootLayout";
import { translate } from "../utils";

const HPFC: FC = (): JSX.Element => {
  const { locale } = useRouter();

  const introContent = {
    pageName: "hpfc-electricity",
    title: translate(locale, "hpfc_title"),
    subTitle: translate(locale, "hpfc_subtitle"),
    description: translate(locale, "hpfc_description"),
  };

  const aboutAppContent = {
    imageName: "market-data-app",
    description: translate(locale, "hpfc_electricity_text"),
  };

  const aboutCompanyContent = {
    title: translate(locale, "hpfc_content_title"),
    description: translate(locale, "hpfc_content_description"),
  };

  const benefitsItem = [
    translate(locale, "hpfc_benefit_first"),
    translate(locale, "hpfc_benefit_second"),
    translate(locale, "hpfc_benefit_third"),
    translate(locale, "hpfc_benefit_fourth"),
    translate(locale, "hpfc_benefit_fifth"),
    translate(locale, "hpfc_benefit_sixt"),
  ];

  const GetInterestedContent = {
    title: translate(locale, "interested_content_title"),
    description: translate(locale, "interested_content_description"),
  };

  return (
    <div>
      <Intro
        title={introContent.title}
        subTitle={introContent.subTitle}
        pageName={introContent.pageName}
        description={introContent.description}
      />
      <AboutApp
        imageName={aboutAppContent.imageName}
        description={aboutAppContent.description}
      />
      <AboutCompany
        title={aboutCompanyContent.title}
        description={aboutCompanyContent.description}
      />
      <Benefits items={benefitsItem} />
      <GetInterested
        title={GetInterestedContent.title}
        description={GetInterestedContent.description}
      />
      
      <Contacts pageName="hpfc-electricity" />
    </div>
  );
};

export default WithRootLayout(HPFC);
